export type RowIdentity = {
  wrNum: number;
  rowKeyNum: number;
  rowKey: string;
  imageKey: string;
  safeWrId: number | null;
};

const getRowNumericKey = (wrNum: number, idx: number): number => {
  return Number.isFinite(wrNum) ? wrNum : -(idx + 1);
};

export const buildRowIdentity = (wrId: unknown, idx: number): RowIdentity => {
  // WebSocket/state keys are wr_id based. Keep this identical to pre-refactor behavior.
  const wrNum = Number(wrId);
  return {
    wrNum,
    rowKeyNum: getRowNumericKey(wrNum, idx),
    rowKey: Number.isFinite(wrNum) ? `row-${wrNum}` : `row-${idx}`,
    imageKey: Number.isFinite(wrNum) ? `img-${wrNum}` : `img-${idx}`,
    safeWrId: Number.isFinite(wrNum) ? wrNum : null,
  };
};
